exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1M7BOT0FSOTl2E{align-items:flex-start}", ""]);

// exports
exports.locals = {
	"createTeamOverlay": "_1M7BOT0FSOTl2E"
};